module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduct"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('strong', [_vm._v("SECTION ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("WHAT DID I JUST DRINK?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('strong', [_vm._v("A GUIDE TO BEER STYLES (AND HISTORY!)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('strong', [_vm._v("chapter one")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("BREAKING DOWN BEER STYLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_c('strong', [_vm._v("chapter two")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_vm._v("THE LIGHTEST OF LIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#chapsec1lev1"
    }
  }, [_vm._v("pale lagers")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#chapsec1lev2"
    }
  }, [_vm._v("Bohemian (Czech) pilsener")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#chapsec1lev3"
    }
  }, [_vm._v("Munich helles")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#chapsec1lev4"
    }
  }, [_vm._v("German pilsner")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#chapsec1lev5"
    }
  }, [_vm._v("dortmunder export")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#chapsec1lev6"
    }
  }, [_vm._v("hefeweizen/weissbier")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#chapsec1lev7"
    }
  }, [_vm._v("class (premium) American pilsner")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#chapsec1lev8"
    }
  }, [_vm._v("kölsch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch03"
    }
  }, [_c('strong', [_vm._v("chapter three")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch03"
    }
  }, [_vm._v("THE DARKER SIDE OF LIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch03#chapsec1lev9"
    }
  }, [_vm._v("amber and dark lagers")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch03#chapsec1lev10"
    }
  }, [_vm._v("schwarzbier (black lager)")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch03#chapsec1lev11"
    }
  }, [_vm._v("Munich dunkel")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch03#chapsec1lev12"
    }
  }, [_vm._v("Vienna lager")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch03#chapsec1lev13"
    }
  }, [_vm._v("Oktoberfest (marzen)")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch03#chapsec1lev14"
    }
  }, [_vm._v("steam beer/California common")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter four")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE IPA AND ITS EMERGING SUBCATEGORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English IPA")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American india pale ale")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("imperial (double) india pale ale")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("black IPA/ American black ale")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belgian-style IPA")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("white IPA")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("india session ale/session IPA")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("brettanomyces/wild IPA")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("red IPA")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rye IPA")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#chapsec1lev25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("spiced/herbed tea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter five")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE OTHER HOPPY BEERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#chapsec1lev26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ordinary bitter (session ale)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05#chapsec1lev27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("extra special bitter (ESB)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05#chapsec1lev28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American pale ale")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05#chapsec1lev29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American amber ale")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05#chapsec1lev30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American brown ale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter six")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE DARKER SIDE OF ALE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English mild")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("porter")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Irish) dry stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sweet/milk stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("oatmeal stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("foreign export stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Russian imperial stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chocolate stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("coffee stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("oyster stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scottish ales")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#chapsec1lev43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish red ale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter seven")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEANWHILE, IN BELGIUM …")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#chapsec1lev44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belgian blonde ale")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch07#chapsec1lev45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belgian tripel")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch07#chapsec1lev46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belgian dubbel")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch07#chapsec1lev47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("witbier")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch07#chapsec1lev48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("saison (farmhouse)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch07#chapsec1lev49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biere de Garde")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter eight")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIG, BOLD, AND BRAZEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#chapsec1lev50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English barleywine")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#chapsec1lev51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American barleywine")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#chapsec1lev52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baltic porter")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#chapsec1lev53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Russian imperial stout")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#chapsec1lev54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("bock")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#chapsec1lev55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("maibock (helles bock)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#chapsec1lev56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("doppelbock (double bock)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#chapsec1lev57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eisbock")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#chapsec1lev58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("weizenbock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter nine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOUR AND BARREL-AGED BEERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#chapsec1lev59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("gueuze")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#chapsec1lev60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flanders red ale")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#chapsec1lev61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flanders oud bruin (brown ale)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#chapsec1lev62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leipzig-style gose")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#chapsec1lev63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berliner weisse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SECTION TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BECOMING AN EXPERT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE BREWING PROCESS, BREWING INGREDIENTS, EVALUATING BEER, AND RESPECTING BEER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter ten")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BREWING AND BEER INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#chapsec1lev64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("malt")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10#chapsec1lev65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("hops")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10#chapsec1lev66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("yeast")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10#chapsec1lev67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("brettanomyces")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10#chapsec1lev68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("water")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter eleven")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EVALUATING BEER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#chapsec1lev69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("tasting conditions")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch11#chapsec1lev70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("appearance")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch11#chapsec1lev71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("aroma")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch11#chapsec1lev72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("flavor")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch11#chapsec1lev73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("mouthfeel")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch11#chapsec1lev74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("overall impression")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter twelve")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RESPECTING BEER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#chapsec1lev75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("storing beer")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch12#chapsec1lev76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("freshness")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch12#chapsec1lev77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("cellaring beer")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch12#chapsec1lev78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pouring beer")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch12#chapsec1lev79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("temperature (bottles)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch12#chapsec1lev80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("temperature (draft)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch12#chapsec1lev81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("glassware")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SECTION THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAVING FUN WITH BEER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PAIRING BEER WITH FOOD, COOKING WITH BEER, BEER MIXOLOGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter thirteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PAIRING BEER WITH FOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#chapsec1lev82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("getting started")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch13#chapsec1lev83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pairing beer with cheese")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch13#chapsec1lev84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pairing beer with tacos")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch13#chapsec1lev85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pairing beer with pizza")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter fourteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COOKING WITH BEER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#chapsec1lev86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("the basics")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14#chapsec1lev87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("soups, stews, and chili")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14#chapsec1lev88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("breads and batters")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14#chapsec1lev89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("condiments, sauces, and dressings")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14#chapsec1lev90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("meat and seafood")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14#chapsec1lev91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vegetarian recipes")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch14#chapsec1lev92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("desserts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("chapter fifteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BEER MIXOLOGY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc6"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#chapsec1lev93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("getting started")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15#chapsec1lev94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("beer blends (the spiritless cocktails)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15#chapsec1lev95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("beer cocktails (with spirits)")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15#chapsec1lev96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("bourbon cocktails")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15#chapsec1lev97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("gin cocktails")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15#chapsec1lev98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rum cocktails")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15#chapsec1lev99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("beer flips")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15#chapsec1lev100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("tequila and mezcal cocktails")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch15#chapsec1leva",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vodka cocktails")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/resources",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("BEER RESOURCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ACKNOWLEDGMENTS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0